<template>
  <SectionContainer v-if="formUrl">
    <div class="company-wall-how-it-works">
      <SHeading class="company-wall-how-it-works__heading" level="2" size="2">
        {{ tr("main_site.company_wall.how_it_works.title") }}
      </SHeading>
      <div class="company-wall-how-it-works__cards">
        <HowItWorksStepCard
          :description="
            tr('main_site.company_wall.how_it_works.step_1.description')
          "
          :number="1"
          :title="tr('main_site.company_wall.how_it_works.step_1.title')"
        />
        <HowItWorksStepCard
          :description="
            tr('main_site.company_wall.how_it_works.step_2.description')
          "
          :number="2"
          :title="tr('main_site.company_wall.how_it_works.step_2.title')"
        />
        <HowItWorksStepCard
          :description="
            tr('main_site.company_wall.how_it_works.step_3.description')
          "
          :number="3"
          :title="tr('main_site.company_wall.how_it_works.step_3.title')"
        />
      </div>
      <SButton color="accent" :to="formUrl">
        {{ tr("main_site.company_wall.how_it_works.cta") }}
      </SButton>
    </div>
  </SectionContainer>
</template>

<script setup lang="ts">
import { SButton } from "@solvari/common-fe";
import { SHeading } from "@solvari/components";
import {
  injectI18nLocale,
  useI18nMainSiteCompanyWall,
} from "@solvari/translations";

import SectionContainer from "~/shared/components/SectionContainer.vue";

import { useLocalSearchTranslations } from "../../composables/useLocalSearchTranslations.ts";
import HowItWorksStepCard from "./HowItWorksStepCard.vue";

const props = defineProps<{
  formUrl: string | null;
  routeParams: { geoProductSlug: string; province: string };
}>();

const localeCode = injectI18nLocale().value;

const { tr } = useLocalSearchTranslations(useI18nMainSiteCompanyWall, {
  localeCode,
  geoProductSlug: props.routeParams.geoProductSlug,
  province: props.routeParams.province,
});
</script>

<style lang="postcss">
.company-wall-how-it-works {
  @apply flex flex-col items-center gap-8;

  &__heading {
    @apply text-center;
  }

  &__cards {
    @apply flex w-full flex-col gap-4;

    @screen 700 {
      @apply flex-row;
    }
  }
}
</style>
